"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    en: {
        1: {
            info: {
                p: "Sign in",
                buttons: { 1: "Sign In as a Patient", 2: "Sign In as a Therapist" },
            },
            step: "Step 1",
        },
        2: {
            info: {
                p: "Perform calibration to adapt algorithm to the face parameters",
                buttons: { 1: "Perform calibration" },
            },
            step: "Step 2",
        },
        3: {
            info: {
                p: "Select exercises for an Individual plan of care",
                popUpMessage: "Go to your patient's profile to select exercises for your patients",
                buttons: { 1: "Create exercises plan" },
            },
            step: "Step 3",
        },
        4: {
            info: {
                p: "When each exercise is performed for the first time, individual goals will be automatically set, but you can adjust them manually if necessary",
            },
            step: "Step 4",
        },
        5: {
            info: {
                p: "Then, all exercises will be evaluated according to set individual goals",
            },
            step: "Step 5",
        },
        6: {
            info: {
                p: "Track progress and analyze reports to revise the plan of care accordingly",
                popUpMessage: "Go to your patient's profile to access their reports",
                buttons: { 1: "Track progress" },
            },
            step: "Step 6",
        },
    },
    ru: {
        1: {
            info: {
                p: "Зарегистрироваться",
                buttons: {
                    1: "Зарегистрироваться как пациент",
                    2: "Зарегистрироваться как логопед",
                },
            },
            step: "Шаг 1",
        },
        2: {
            info: {
                p: "Выполните калибровку, чтобы адаптировать алгоритм к параметрам лица",
                buttons: { 1: "Пройти калибровку" },
            },
            step: "Шаг 2",
        },
        3: {
            info: {
                p: "Выберите упражнения для Индивидуального плана занятий",
                popUpMessage: "Для выбора упражнений зайдите в профиль своего пациента",
                buttons: { 1: "Составить план занятий" },
            },
            step: "Шаг 3",
        },
        4: {
            info: {
                p: "При первом выполнении каждого упражнения будут автоматически подобраны индивидуальные цели, которые, при необходимости, можно скорректировать",
            },
            step: "Шаг 4",
        },
        5: {
            info: {
                p: "Далее все упражнения будут оцениваться в соответствии с индивидуальными целями",
            },
            step: "Шаг 5",
        },
        6: {
            info: {
                p: "Отслеживайте прогресс и анализируйте отчеты, чтобы соответствующим образом пересмотреть план лечения",
                popUpMessage: "Для просмотра отчетов зайдите в профиль своего пациента",
                buttons: { 1: "Отслеживать прогресс" },
            },
            step: "Шаг 6",
        },
    },
    uz: {
        1: {
            info: {
                p: "Ro'yxatdan o'tish",
                buttons: {
                    1: "Bemor sifatida ro'yxatdan o'ting",
                    2: "Lodoped sifatida ro'yxatdan o'ting",
                },
            },
            step: "1-qadam",
        },
        2: {
            info: {
                p: "Algoritmni yuz parametrlariga moslashtirish uchun kalibrlashni bajaring",
                buttons: { 1: "Kalibrlash" },
            },
            step: "2-qadam",
        },
        3: {
            info: {
                p: "Shaxsiy Dars Rejasiga uchun mashqlarni tanlang",
                popUpMessage: "Shaxsiy Dars Rejasiga uchun mashqlarni tanlang",
                buttons: { 1: "Dars rejasini tuzing" },
            },
            step: "3-qadam",
        },
        4: {
            info: {
                p: "Har bir mashqni birinchi marta bajarganingizda, individual maqsadlar avtomatik ravishda tanlanadi, agar kerak bo'lsa, ularni sozlash mumkin.",
            },
            step: "4-qadam",
        },
        5: {
            info: {
                p: "Keyin barcha mashqlar individual maqsadlarga qarab baholanadi",
            },
            step: "5-qadam",
        },
        6: {
            info: {
                p: "Davolanish rejangizni mos ravishda qayta ko'rib chiqish uchun taraqqiyotingizni kuzatib boring va hisobotlarni tahlil qiling",
                popUpMessage: "Hisobotlarni ko'rish uchun bemor profilingizga kiring",
                buttons: { 1: "Taraqqiyotni kuzatish" },
            },
            step: "6-qadam",
        },
    },
    kz: {
        1: {
            info: {
                p: "Тіркелу",
                buttons: {
                    1: "Пациент ретінде тіркелу",
                    2: "Логопед ретінде тіркелу",
                },
            },
            step: "1-қадам",
        },
        2: {
            info: {
                p: "Алгоритмді бет параметрлеріне бейімдеу үшін калибрлеуден өтіңіз",
                buttons: { 1: "Калибрлеуден өту" },
            },
            step: "2-қадам",
        },
        3: {
            info: {
                p: "Жеке жаттығу жоспары үшін жаттығуларды таңдаңыз",
                popUpMessage: "Жаттығуларды таңдау үшін пациент профиліне кіріңіз",
                buttons: { 1: "Жаттығу жоспарын құру" },
            },
            step: "3-қадам",
        },
        4: {
            info: {
                p: "Әр жаттығуды алғаш орындау кезінде жеке мақсаттар автоматты түрде таңдалады, қажет болған жағдайда оларды түзетуге болады",
            },
            step: "4-қадам",
        },
        5: {
            info: {
                p: "Одан кейін барлық жаттығулар жеке мақсаттарға сәйкес бағаланады",
            },
            step: "5-қадам",
        },
        6: {
            info: {
                p: "Прогресті бақылап, есептерді талдау арқылы емдеу жоспарын сәйкесінше қайта қараңыз",
                popUpMessage: "Есептерді көру үшін пациент профиліне кіріңіз",
                buttons: { 1: "Прогресті бақылау" },
            },
            step: "6-қадам",
        },
    },
};
